import { MemberShipProduct } from './membership'

export interface UserPersonal {
	[index: string]: any
	name: string
	email: string
	imageUrl?: string
	dateOfBirth: string
	gender: string
	phone?: string
	firstName: string
	lastName: string
	address1: string
	address2?: string
	city: string
	ZipCode: string
	Country: string
	state: string
	notes?: string
	cvUrl?: string
}
export interface UserEmployment {
	[index: string]: any
	roles: Array<USER_ROLES>
	employer?: string
	accounts: Array<string>
	expertise: Array<string>
	patientCapacityLoad: number
	roleTypes?: Array<string>
	skills: Array<string>
	startOfService: string
	title: string
}
export interface UserExtra {
	[index: string]: any
	firstLogin?: boolean
	organizationID: string
	active?: boolean
	coachId?: string
	firstPassword?: string
}
export interface UserLocalization {
	[index: string]: any
	carbs: string
	dateConfiguration: string
	glucoseLevel: string
	language: string
	temperature: string
	weightHeight: string
}
export interface User {
	[index: string]: any | undefined
	personal: UserPersonal
	employment: UserEmployment
	extra?: UserExtra
	notes: string
	localization: UserLocalization
	myOrganization?: {
		orgName: string
		orgId: string
		imageUrl: string
		accounts: Array<any>
		['business_calender']: MyOrganizationBusinessCalendar
		['general_info']: MyOrganizationGeneralInfo
		licenseFeatures: object
		questionnaire: Array<UserOrganizationQuestionnaire>
		membershipEnrollment: MyOrganizationMembershipEnrollment
		educationalContent: Array<UserOrganizationEducationalContent>
		internalClinic: boolean
		eventCategoriesV2: Array<MyOrganizationEventCategory>
		userToEngageInactiveSLA: number
		userToEngageNewSLA: number
		coachCapacityLoad: number
	}
	organizations?: Array<Organization>
	termsOfService?: {
		approved: boolean
	}
	created?: string
	modified?: string
	_id?: string
	__v?: number
}

export interface MyOrganizationEventCategory {
	id: number
	value: string
}

export interface MyOrganizationMembershipEnrollment {
	products: Array<MemberShipProduct>
}

export interface MyOrganizationGeneralInfo {
	description: MyOrganizationGeneralInfoDescription
	address: MyOrganizationGeneralInfoAddress
}
export interface MyOrganizationGeneralInfoDescription {
	details: GeneralInfoDescriptionDetails
	['primary_contact_person']: GeneralInfoDescriptionContactPerson
}
export interface GeneralInfoDescriptionDetails {
	['org_phone']: string
	['org_type']: string
	['org_status']: string
	['affiliation_id']: string
	['description_text']: string
	website: string
}

export interface GeneralInfoDescriptionContactPerson {
	email: string
	name: string
	phone: string
}

export interface MyOrganizationGeneralInfoAddress {
	['shipping_address']: GeneralInfoAddressItem
	['mailing_address']: GeneralInfoAddressItem
}

export interface GeneralInfoAddressItem {
	['address_line1']: string
	['address_line2']: string
	state: string
	country: string
	city: string
	['zip_code']: string
}

export interface MyOrganizationBusinessCalendar {
	weekDays: Array<Boolean>
	workingHours: BusinessCalendarWorkingHours
	timezone: string
	phone: string
	workHours: string
	holidays: Array<any>
}

export interface MyOrganizationBusinessParameters {
	userToEngageInactiveSLA: number
	userToEngageNewSLA: number
	coachCapacityLoad: number
}

export interface BusinessCalendarWorkingHours {
	from: string
	to: string
}
export interface Organization {
	orgName: string
	orgId: string
	_id: string
	imageUrl: string
	// eslint-disable-next-line camelcase
	general_info?: any
}
export interface UserOrganizationQuestionnaire {
	id: string
	['ui_text']: string
	metadata: {
		form: UserOrganizationQuestionnaireForm
	}
}

export interface UserOrganizationQuestionnaireForm {
	title: {
		textContent?: string
	}
	field: Array<UserOrganizationQuestionnaireFormField>
	id: string
	htmlsection: {
		textContent: string
	}
}

export interface UserOrganizationQuestionnaireFormField {
	id: string
	label: {
		textContent: string
	}
	choices?: {
		choice: Array<Omit<UserOrganizationQuestionnaireFormField, 'choices'>>
	}
	type: string
	choiceValue?: string
}

export enum EduAndDocumentState {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
}

export interface UserOrganizationEducationalContent {
	id: number
	_id?: string
	['ui_text']: string
	state: EduAndDocumentState
	documents: UserOrganizationDocument[]
}

export interface UserOrganizationDocument {
	body: string
	link: string
	['link_text']: string
	state: EduAndDocumentState
	subject: string
	text: string
	_id?: string
	isFav?: boolean
}

export enum USER_ROLES {
	SYSTEM_ADMIN = 'system_admin',
	ORG_ADMIN = 'org_admin',
	COACH = 'coach',
	ACCOUNT_ADMIN = 'account_admin',
	TEST_ADMIN = 'test_admin',
}

export enum UserActionTypes {
	USER_GET = 'USER_GET',
	USER_UPDATE_LOCALIZATION = 'USER_UPD_LOCALIZATION',
}

export interface UserGetAction {
	type: UserActionTypes.USER_GET
	payload: User
}

export interface UserUpdLocalizationAction {
	type: UserActionTypes.USER_UPDATE_LOCALIZATION
	payload: UserLocalization
}

export type UserAction = UserGetAction | UserUpdLocalizationAction

export interface UsersDataTableModel {
	_id: string
	name: string
	language: string
	organization: string
	role: string
	tier: string
	status: string
	email: string
}
